'use strict';

/*global app*/
/*global blockElement*/
/*global unBlockElement*/

function CommonProcessService() {
  this.$container = $('body');

  this.init();
}

CommonProcessService.prototype = $.extend({}, {
  constructor: 'CommonProcessService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  getDocumentsByWarehouseDocument: function getDocumentsByWarehouseDocument(webDocumentRID, callback) {
    var _this = this;

    blockElement(_this.$container);
    $.get(app.path('process_get_documents', { WebDocumentRID: webDocumentRID }), function (res) {
      unBlockElement(_this.$container);
      if (res.msg === 'SUCCESS') {
        callback(res.data);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});

